import {
  IsInt,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
  Min,
} from 'class-validator';
import { BaseCreateDto, BaseUpdateDto } from './base.dto';
import type { NamedEntityDto } from './clinical-details/named.dto';
import type { SpecialityDto } from './speciality.dtos';

// `name`/`name_da`/`name_de` are inherited from NamedEntityDto — condition-type
// names are free-text DB reference data (admin-managed), not the `ConditionType`
// union; dermatology-specific logic narrows to the union at its own boundary.
export interface ConditionTypeDto extends NamedEntityDto {
  specialityId: string;
  // Optional: relation-loaded. Shields consumers reading the 1h-stale Redis
  // cache from assuming presence — always fall back to specialityId.
  speciality?: SpecialityDto;
  /** Display position within the speciality, ascending; ties break on name. */
  ordering?: number;
}

export class CreateConditionTypeDto
  extends BaseCreateDto
  implements Partial<ConditionTypeDto>
{
  @IsNotEmpty()
  @IsString()
  name: string;

  @IsOptional()
  @IsString()
  name_da?: string;

  @IsOptional()
  @IsString()
  name_de?: string;

  @IsUUID()
  specialityId: string;

  @IsInt()
  @Min(0)
  ordering: number;
}

// No `name`: capture branches on it. No `specialityId`: moves are migrations.
export class UpdateConditionTypeDto extends BaseUpdateDto {
  /** Null clears it; undefined leaves it. */
  @IsOptional()
  @IsString()
  name_da?: string | null;

  @IsOptional()
  @IsString()
  name_de?: string | null;
}
